import { useAPIQuery, UserAccountApi } from "melco-shared-logic";

const NOTIFICATIONS_REFETCH_INTERVAL_SHORT = 8000;
const NOTIFICATIONS_REFETCH_INTERVAL_LONG = 30000;

export const NOTIFICATIONS_CACHE_KEY = "notifications";

export const useNotifications = (popoverOpen?: boolean) => {
  return useAPIQuery(
    UserAccountApi,
    [NOTIFICATIONS_CACHE_KEY],
    async (api) =>
      api.userProductNotificationsGetList({
        productCode: process.env.REACT_APP_PRODUCT_CODE!,
      }),
    {
      queryOptions: {
        refetchInterval: popoverOpen
          ? NOTIFICATIONS_REFETCH_INTERVAL_SHORT
          : NOTIFICATIONS_REFETCH_INTERVAL_LONG,
      },
    }
  );
};
